export const thinScrollbar = {
    thinScrollbar: {
        '&::-webkit-scrollbar': {
            width: '0.4em',
            height: '0.7em'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.3)',
            borderRadius: '5px'
        }
    },
}
export const aletheaOrange = "#f36c24"
export const aletheaOrangeLight = "#f2b899"
